import './settings.scss';
import { Link } from 'react-router-dom';
import PseudoTerminal from '../../components/admin/PseudoTerminal';
import Banner from '../../components/banner/Banner';

export default function SettingsPage() {
    return (
        <div className="settings">
            <Banner title="Settings" />
            <div className="settingsContent">
                <PseudoTerminal />
            </div>
        </div>
    );
    }